import React, { useState } from "react";
import "./ImageManager.css";
import defaultHeaderPhoto from "../../defaultHeaderPhoto.png";
import Modal from "react-modal";
import { imageServerUrl, imageSizes } from "../../constants/config";
import ImageModal from "./ImageModal";
import { CiImageOn } from "react-icons/ci";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
interface ImageManagerProps {
  images: any[];
}
const ImageManager: React.FC<ImageManagerProps> = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [openModal, setOpenModal] = useState(false);

  const getImageUrl = (id: string | undefined, size: string): string => {
    if (!id) return defaultHeaderPhoto;
    return `${imageServerUrl}/image/${size}/${id}`;
  };
  const renderImageIcon = () => {
    const ImageIcon = CiImageOn as any;
    return <ImageIcon />;
  };

  const renderDirectionIcon = (direction: "left" | "right") => {
    if (direction === "left") {
      const LeftIcon = FaChevronLeft as any;
      return <LeftIcon />;
    }
    // For right direction, we can use the same icon but rotate it
    const RightIcon = FaChevronRight as any;
    return <RightIcon />;
  }
  if (images.length === 0) {
    return (
      <div className="image-manager-container">
        <div className="large-image-container">
          <img src={defaultHeaderPhoto} alt="" className="large-image" />
        </div>
      </div>
    );
  }
  return (
    <div className="image-manager-container">
      <div className="large-image-container" onClick={() => setOpenModal(true)}>
        <img
          src={getImageUrl(images[currentIndex]?.ID, imageSizes.large)}
          alt=""
          loading="eager"
          onError={(e) => { (e.target as HTMLImageElement).src = defaultHeaderPhoto; }}
          className="large-image"
        />
        <div className="image-counter" onClick={(e) => { e.stopPropagation(); }}>
          <div className="image-counter-info">
            <span className="image-counter-icon">{renderImageIcon()}</span>{" "}
            {currentIndex + 1} / {images.length}
          </div>
          <div className="image-counter-navigation">
            <span className="image-counter-direction" onClick={() => setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : images.length - 1))}> {renderDirectionIcon("left")} </span>
            <span className="image-counter-direction" onClick={() => setCurrentIndex((prevIndex) => (prevIndex < images.length - 1 ? prevIndex + 1 : 0))}> {renderDirectionIcon("right")} </span>
          </div>
        </div>
      </div>
      <div className="thumbnail-images-container">
        {images.map((img, index) => (
          <div
            key={index}
            className="thumbnail-image-box"
            onClick={() => setCurrentIndex(index)}
          >
            <img
              src={getImageUrl(img.ID, imageSizes.medium)}
              alt=""
              onError={(e) => { (e.target as HTMLImageElement).src = defaultHeaderPhoto; }}
              className="thumbnail-image"
              loading="lazy"
            />
          </div>
        ))}
      </div>
      <Modal
        isOpen={openModal}
        onRequestClose={() => setOpenModal(false)}
        overlayClassName={"modal-overlay"}
        className={"modal-content"}
        shouldCloseOnOverlayClick={true}
      >
        <ImageModal images={images} />
      </Modal>
    </div>
  );
};

export default ImageManager;
